import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import logoIcon from "../assets/images/logo.png";

const PdfDownloader = ({ fileName, children }) => {
  const captureScreen = async () => {
    const element = document.querySelector(".main");
    if (!element) {
      console.error("Element with class 'main' not found.");
      return;
    }

    // Hide unwanted sections
    const excluded = element.querySelectorAll(
      ".heading-wrap, .steps-form,.video-slider-section"
    );
    excluded.forEach((el) => (el.style.display = "none"));

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;

    // Capture remaining content
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#F5F6FA",
      windowWidth: document.documentElement.scrollWidth,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const imgWidth = pageWidth - 2 * margin;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let yPosition = margin;

    // Add logo to first page
    const logoImg = new Image();
    logoImg.src = logoIcon;
    await new Promise((resolve) => (logoImg.onload = resolve));

    const logoWidth = pageWidth * 0.3;
    const logoHeight = (logoWidth * 8) / 50;

    const logoX = pageWidth - logoWidth - margin;
    const logoY = margin;

    pdf.addImage(logoImg, "PNG", logoX, logoY, logoWidth, logoHeight);
    yPosition += logoHeight + 10;

    pdf.addImage(imgData, "JPEG", margin, yPosition, imgWidth, imgHeight);
    heightLeft -= pageHeight - margin;

    while (heightLeft > 0) {
      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        margin,
        margin - (imgHeight - heightLeft),
        imgWidth,
        imgHeight
      );
      heightLeft -= pageHeight - margin;
    }

    // Restore hidden sections
    excluded.forEach((el) => (el.style.display = ""));

    pdf.save(fileName || "document.pdf");
  };

  return <div onClick={captureScreen}>{children}</div>;
};

export default PdfDownloader;
